import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "campaigns-thin",
  "use": "campaigns-thin-usage",
  "viewBox": "0 0 922 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 922 1024\" id=\"campaigns-thin\">\n<title></title>\n<g id=\"campaigns-thin_icomoon-ignore\">\n</g>\n<path d=\"M153.6 700.632v-377.263l768-323.368v1024l-768-323.368zM819.2 153.6l-563.2 220.554v275.692l563.2 220.554v-716.8zM0 307.2v563.2h102.4v-563.2h-102.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol